import { render, staticRenderFns } from "./reCAPTCHAv3.vue?vue&type=template&id=16da44bb&"
import script from "./reCAPTCHAv3.vue?vue&type=script&lang=js&"
export * from "./reCAPTCHAv3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports